import { TypeIFrameFields } from 'contentful-types'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import IFrame from './IFrame'

const ContentfulIFrame = withContentful<TypeIFrameFields>(IFrame, {
  url: (props) => props.fields.url,
  screenReaderTitle: (props) => props.fields.screenReaderTitle,
  height: (props) => {
    return {
      xs: props.fields?.heightXS,
      sm: props.fields?.heightSM,
      md: props.fields?.heightMD,
      lg: props.fields?.heightLG,
      xl: props.fields?.heightXL,
    }
  },
  fullHeight: (props) => props.fields.fullHeight,
})

export default ContentfulIFrame
